import styled from "styled-components";

export const CommentLinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 3rem;
`;
